// src/pages/dashboard/DashboardPage.jsx
import React from "react";
import { Box, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { selectUser } from "../../store/slices/authSlice";
import { useAuth } from "../../components/features/auth/AuthGuard";
import { ROLES } from "../../constants";

// Role-based dashboard components
import AdminDashboard from "../../components/features/dashboard/AdminDashboard";
import FinanceManagerDashboard from "../../components/features/dashboard/FinanceManagerDashboard";
import PersonalDashboard from "../../components/features/dashboard/PersonalDashboard";

const DashboardPage = () => {
  const user = useSelector(selectUser);
  const { hasAnyRole } = useAuth();

  // Determine which dashboard to show based on user role
  const getDashboardComponent = () => {
    if (hasAnyRole([ROLES.ADMIN])) {
      return <AdminDashboard />;
    } else if (hasAnyRole([ROLES.FINANCE_MANAGER])) {
      return <FinanceManagerDashboard />;
    } else {
      return <PersonalDashboard />;
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {getDashboardComponent()}
    </Box>
  );
};

export default DashboardPage;
